"use client";
const e = Object.freeze({
  lg: "1.25rem",
  md: "1rem",
  sm: "0.75rem"
}), t = Object.keys(e);
export {
  e as ICON_SIZES,
  t as ICON_SIZE_KEYS
};
